<script setup lang="ts">
import { formatAmount } from '@/utils/formatters';
import { computed, inject, onMounted, reactive, ref, toRaw } from 'vue';
import { useRouter } from 'vue-router';
import { useMarketCartStore } from '@/stores/cart.store';

const BACKEND_URL = inject('BACKEND_URL');
const router = useRouter();
const cart = useMarketCartStore();
const layout = ref('none');
const loadingCart = ref(false);
const startupInfos = reactive({
    product: {} as any,
});
const echeancesPaiement = ref([] as any[]);
const formGroup = reactive({
    echeance_id: -1,
});
const currentMontant = computed(() => {
    const echeance = echeancesPaiement.value.find(e => e.value === formGroup.echeance_id);
    return echeance ? echeance.montant : startupInfos.product.montant;
});

onMounted(() => {
  layout.value = router.currentRoute.value.meta.layout as string || 'none';
  Object.assign(startupInfos, router.currentRoute.value.meta.startup_infos);
  echeancesPaiement.value = [
        {
            value: -1,
            label: 'Payer en une fois',
            description: 'Avec le solde de votre wallet',
            montant: startupInfos.product.montant,
        },
        ...startupInfos.product.echeances.map((echeance: any) => ({
            value: echeance.duration,
            label: `Payer en ${echeance.nombre_mensualites} fois`,
            description: `${formatAmount(echeance.montant_mensualite)} F CFA x ${echeance.nombre_mensualites}`,
            montant: echeance.montant_total,
        }))
    ];
});

function addToCart() {
    if (loadingCart.value) { return; }

    loadingCart.value = true;
    if (formGroup.echeance_id === -1) {
        cart.addToCart({
            id: startupInfos.product.id,
            nom: startupInfos.product.nom,
            montant: currentMontant.value,
            image: startupInfos.product.image,
            typePromotion: startupInfos.product.type_promotion,
            montantPromotion: startupInfos.product.montant_promotion,
            montantRemise: 0,
            sousTotal: 0,
            total: 0,
        });
    } else {
        const echeance = toRaw(echeancesPaiement.value).find(e => e.value === formGroup.echeance_id);
        if (echeance) {
            cart.addToCart({
                id: startupInfos.product.id,
                nom: startupInfos.product.nom,
                montant: currentMontant.value,
                image: startupInfos.product.image,
                typePromotion: startupInfos.product.type_promotion,
                montantPromotion: startupInfos.product.montant_promotion,
                echeance: echeance.value,
                montantRemise: 0,
                sousTotal: 0,
                total: 0
            });
        }
    }
    setTimeout(() => loadingCart.value = false, 2000);
}

</script>
<template>
    <main>
        <div class="produit-area">
            <div class="page-space-50" v-if="layout == 'none'"></div>
            <section class="container-small">
                <div class="s10_mobile position-relative" style="height: 380px; display: flex; justify-content: center; align-items: center;">
                    <div class="tag-set justify-content-left" style="top: 0;">
                        <div class="tag2">-20%</div>
                        <!-- <div class="tag-promo">Promo !</div> -->
                    </div>
                    <img :src="BACKEND_URL + '/assets/market_produits/1000/' + startupInfos.product.image" style="max-width: 100%; max-height: 350px;" />
                </div>
                <div class="s1_mobile">&nbsp;</div>
                <div class="s9_mobile">
                    <h1 class="secondary-font mt-5 mb-6">
                        {{ startupInfos.product.nom }}
                    </h1>
                    <h1 class="text-4xl secondary-font mb-5">
                        {{ formatAmount(currentMontant) }} F CFA
                    </h1>
                    <div class="h-0"></div>

                    <div class="card-check bg-white-50 widget active flex my-2 pt-6 pb-5 px-6" v-for="(echeance, index) of echeancesPaiement" :key="index">
                        <label class="s20" :for="'echeance_' + index">
                            <div class="s1 mt-1"><input class="" type="radio" name="echeance" :id="'echeance_' + index" :value="echeance.value" v-model="formGroup.echeance_id" /></div>
                            <h5 class="s14 pl-2 secondary-font">{{ echeance.label }} <br class="mb-3"/>
                                <span class="secondary-font text-grey-600">{{ echeance.description }}</span>
                            </h5>
                            <h4 class="s5 text-right secondary-font">{{ formatAmount(echeance.montant) }} F</h4>
                        </label>
                    </div>
                    <!-- <div class="card-check bg-white-50 widget flex my-2 pt-6 pb-5 px-6">
                        <label class="s20" for="super_1">
                            <div class="s1 mt-1"><input class="" type="radio" name="super" id="super_1" value="1" /></div>
                            <h5 class="s14 pl-2 secondary-font">Payer en plusieurs fois<br class="mb-3"/>
                                <span class="secondary-font text-grey-600">225 000 F CFA x 4</span>
                            </h5>
                            <h4 class="s5 text-right secondary-font">225 000 F <br>/ mois</h4>
                        </label>
                    </div> -->

                    <div class="clear-both h-20"></div>

                    <button class="btn-ultra lg w-100" :class="{'loading': loadingCart}" @click="addToCart" :disabled="loadingCart"><!-- loading sm tips color2 light white white2 success info warning danger-->
                        <div class="btn-show">
                            <img src="/public/icons/icon-panier.svg" class="btn-icon" alt="" />
                            <span>&nbsp;Ajouter au panier</span>
                        </div>
                        <div class="btn-loading">
                            <div class="loader-dots"></div>
                        </div>
                    </button>
                    <div class="h-30"></div>
                </div>
                <div class="clear-both h-10"></div>

                <div class="flex">
                    <p class="s10_mobile text-read" v-html="startupInfos.product.description">
                    </p>
                    <div class="s1_mobile">&nbsp;</div>
                    <div class="s9_mobile ">
                        <div class="mb-6 text-grey-700">
                            <hr/>
                            <h5 class="mt-5 mb-2">Caractéristiques principales :</h5>
                            <p>6,9 pouces Super Retina XDR avec ProMotion 120Hz</p>
                        </div>
                        <div class="mb-6 text-grey-700">
                            <hr/>
                            <h5 class="mt-5 mb-2">Caractéristiques principales :</h5>
                            <p>6,9 pouces Super Retina XDR avec ProMotion 120Hz</p>
                        </div>
                    </div>
                </div>

            </section>

            <div class="clear-both h-60"></div>
        </div>
    </main>
</template>